import { Component, OnInit, Renderer2 } from '@angular/core';
import { sessionStorage } from '../localstorage.service';
import { Router } from '@angular/router';
import { DialogComponent } from '../dialog.component';
import { DatabaseService } from 'src/_services/DatabaseService';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ProgressService } from '../progress.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit {
  searchData: any = {};
  login_data: any = {};
  dataList: any = [];
  downloaderActive$: any = false;
  downloadPercent$ = this.progressService.getDownloadProgress();
  uploadPercent$ = this.progressService.getUploadProgress();
  totalCount = this.progressService.getTotalCount();
  remainingCount = this.progressService.getRemainingCount();
  uploadlogsUrl = this.progressService.getUploaderDownloadUrl();
  uploaderActive$: any = false;
  uploadLogdownload$: any = '';

  constructor(private renderer: Renderer2, public session: sessionStorage, public toastCtrl: ToastrManager, public serve: DatabaseService, public router: Router, public dialog: DialogComponent, public progressService: ProgressService) {
    this.login_data = this.session.getSession();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;


  }

  ngOnInit() {
    this.progressService.getDownloaderActive().subscribe(downloaderActive => {
      this.downloaderActive$ = downloaderActive
    });
    this.progressService.getUploaderActive().subscribe(uploaderActive => {
      this.uploaderActive$ = uploaderActive
    });
    this.progressService.getUploaderDownloadUrl().subscribe(uploadLogdownload => {
      this.uploadLogdownload$ = uploadLogdownload
    });

  }

  colorMode: boolean = false;
  nightMode() {
    this.colorMode = !this.colorMode;
    if (this.colorMode) {
      this.renderer.addClass(document.body, 'dark-mode');
    }
    else {
      this.renderer.removeClass(document.body, 'dark-mode');
    }
  }

  webRefresh() {
    window.location.reload();
  }

  toggle: boolean = false;
  toggleNav() {
    this.toggle = !this.toggle;
    if (this.toggle) {
      this.renderer.addClass(document.body, 'active');
    }
    else {
      this.renderer.removeClass(document.body, 'active');
    }
  }

  filter_dr(search) {
    if (search.length > 3) {
      this.serve.post_rqst({ 'search': search }, "Master/masterSearch").subscribe((result => {
        if (result['statusCode'] == 200) {
          this.dataList = result['result'];
        }
        else {
          this.toastCtrl.errorToastr(result['statusMsg']);
        }
      }))

    }
  }


  id: any
  type: any
  dr_type: any
  gotodetail(data) {
    this.id = data.id
    this.type = data.module_name;
    this.dr_type = data.type
    if (this.type == 'Distributor' || this.type == 'Dealer' || this.type == 'Carpenter' || this.type == 'Contractor' || this.type == 'Architect' || this.type == 'Builder' || this.type == 'OEM' || this.type == 'Fabricator' || this.type == 'Interior Designer') {
      this.router.navigate(['/distribution-list/' + data.type + '/' + data.module_name + '/distribution-detail/' + this.id + '/' + 'Profile', { queryParams: { 'state': data.state, 'id': data.id, 'type': data.type } }])
    }
    else if (this.type == 'Customer' || this.type == 'Plumber') {
      this.router.navigate(['/influencer/' + data.type + '/' + data.module_name + '/influencer-detail/' + this.id + '/' + data.type])
    }
    else if (this.type == '') {
      this.router.navigate(['/sale-user-list/sale-user-detail/' + data.id])
    }
    else if (this.dr_type == '4') {
      this.router.navigate(['/lead-list/lead-detail/' + data.id])
    }
    // else {
    //   this.router.navigate(['/sale-user-list/sale-user-detail/'+data.id]);
    // }
    this.searchData = {}
    this.dataList = [];
  }

  logout() {
    this.dialog.confirm("Logout").then((result) => {
      if (result) {
        this.session.LogOutSession();
        this.serve.datauser = {};
        this.router.navigate(['']);
      }
    });

  }


  cancelDownloading(msgFalse) {
    this.progressService.setCancelReq(true);
    this.serve.post_rqst({ 'search': this.searchData.globalsearch }, "DownloadMaster/cancelDownloadRequest").subscribe((result) => {

      if (result['statusCode'] == 200) {
        this.progressService.setDownloaderActive(false);
        this.progressService.setTotalCount(0);
        this.progressService.setRemainingCount(0);
        this.progressService.setCancelReq(true);
        if (msgFalse != 'msgFalse') {
          this.toastCtrl.successToastr(result['statusMsg'])
        }
        this.cancelRequest();
      }
      else {
        if (msgFalse != 'msgFalse') {
          this.toastCtrl.errorToastr(result['statusMsg'])
        }
      }

    }, err => {
    });





  }
  cancelRequest() {
    setTimeout(() => {
      this.progressService.setDownloaderActive(false);
      this.cancelDownloading('msgFalse');
    }, 300);
  }

}
